import { BrowserRouter } from "react-router-dom";
import "./App.css";
import Layout from "./layout/Layout";
import ScrollToTopButton from "./components/ScrollToTopButton";

function App() {
  return (
    <>
      <BrowserRouter>
        <ScrollToTopButton />
        <Layout />
      </BrowserRouter>
    </>
  );
}

export default App;
